import {Fragment, useState} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Button, Table} from 'semantic-ui-react';
import moment from 'moment-jalaali';
import {ConfirmModal} from '../shared/modals';
import {deleteExamReport} from '../../redux/actions/exam-report';

function ExamReportsList(props) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedExamReportId, setSelectedExamReportId] = useState(0);

  function handleDelete(reportId) {
    setSelectedExamReportId(reportId);
    setShowConfirmModal(true);
  }

  function handleConfirm() {
    props.deleteExamReport(selectedExamReportId);
    setSelectedExamReportId(0);
    setShowConfirmModal(false);
  }

  function handleCancel() {
    setSelectedExamReportId(0);
    setShowConfirmModal(false);
  }

  return (
    <Fragment>
      <Table striped unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>تاریخ آزمون</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>آزمون</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>نتیجه آزمون</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>عملیات</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {props.examReports.map(examReport => {
            const isDeletable = moment().diff(moment(examReport.date), 'days') < 4;
            return (
              <Table.Row key={examReport.id}>
                <Table.Cell textAlign='center'>
                  <p>{moment(examReport.date).format('dddd')}</p>
                  <p>{moment(examReport.date).format('jYY/jMM/jDD')}</p>
                </Table.Cell>
                <Table.Cell textAlign='center'>
                  {examReport.examName}
                </Table.Cell>
                  <Table.Cell textAlign='center'>{`${examReport.result}%`}</Table.Cell>
                  <Table.Cell textAlign='center'>
                    {isDeletable && (
                      <Button
                        basic
                        icon='trash alternate'
                        color='red'
                        size='mini'
                        onClick={handleDelete.bind(null, examReport.id)}
                      />
                    )}
                  </Table.Cell>
                </Table.Row>
              );
            })
          }
        </Table.Body>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan={4}>
              <Button
                as={Link}
                to='/exam-report'
                floated='right'
                primary
                size='small'
                content={'ثبت نتیجه آزمون جدید'}
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
      <ConfirmModal
        open={showConfirmModal}
        content='آیا از پاک کردن این گزارش آزمون مطمئنید؟'
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </Fragment>
  );
}

ExamReportsList.propTypes = {
  examReports: PropTypes.arrayOf(PropTypes.object)
};

export default connect(null, {deleteExamReport})(ExamReportsList);
